export default {
    data() {
        return {
            PENDING_STATUS: 0,
            APPROVE_STATUS: 1,
            REJECT_STATUS: 2,
            COMPLETED_STATUS: 3
        };
    },
    methods: {
        getStatusLabel(item, codeOnly = false) {
            if (item.completed_at)
                return codeOnly
                    ? this.COMPLETED_STATUS
                    : "<span>Completed</span>";
            if (item.status == this.PENDING_STATUS)
                return codeOnly
                    ? this.PENDING_STATUS
                    : "<strong>Pending</strong>";
            if (item.status == this.APPROVE_STATUS)
                return codeOnly ? this.APPROVE_STATUS : "<span>Approved</span>";
            if (item.status == this.REJECT_STATUS)
                return codeOnly ? this.REJECT_STATUS : "<span>Denied</span>";
        }
    }
};
